import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';
import { createOrgTree } from '../peopleManagement.mock';

const getOrgCanvasUsersData = rest.get(
    `${API_REST_URL}/org-canvas/:clientId/:userId`,
    (req, res, ctx) => {
        return res(
            ctx.json({
                data: createOrgTree(5, 5, 6),
                status: 'success',
            }),
        );
    },
);

export const peopleManagementHandlers = [getOrgCanvasUsersData];
